var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateButton } from '../../components/CreateButton';
import { FilterComponent } from '../../components/Pagination/FilterComponent';
import { ListProvider, } from '../../components/Pagination/ListContext';
import { OrderComponent } from '../../components/Pagination/OrderComponent';
import { PaginationComponent } from '../../components/Pagination/PaginationComponent';
import { RenderList } from '../../components/Pagination/RenderList';
import { RequestLoadingIndicator } from '../../components/RequestLoadingIndicator';
import { SituacaoProcessoEnum, SituacaoProcessoLabels, SituacaoProcessoStatusIndicator, } from '../../enums/situacao-processo.enum';
import { searchProcesso } from '../../services/processo.service';
import { formatarData } from '../../util/date.util';
import { formatCnpj } from '../../util/masks';
var getStatus = function (processo) { return SituacaoProcessoStatusIndicator[processo.situacao]; };
var filterFields = [
    { label: 'Número', name: 'numero', type: 'text' },
    {
        label: 'Situação',
        name: 'situacao',
        type: 'select',
        options: SituacaoProcessoLabels,
    },
];
export var ProcessoListPage = function () {
    var loading = useState(false)[0];
    var navigate = useNavigate();
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClickNew = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleClickCredenciamentoInicial = function () {
        handleClose();
        navigate('/processo/novo');
    };
    var handleClickRenovacao = function () {
        handleClose();
        navigate('/processo/renovacao');
    };
    return (_jsxs(ListProvider, { fetchItems: searchProcesso, filterFields: filterFields, children: [_jsx(RequestLoadingIndicator, { loading: loading }), _jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 1, children: [_jsxs(Box, { children: [_jsx(OrderComponent, {}), _jsx(FilterComponent, {})] }), _jsx(CreateButton, { size: "small", variant: "outlined", startIcon: _jsx(AddIcon, {}), onClick: handleClickNew, children: "Novo Processo" }), _jsxs(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                            'aria-labelledby': 'basic-button',
                        }, children: [_jsx(MenuItem, { onClick: handleClickCredenciamentoInicial, children: "Credenciamento Inicial" }), _jsx(MenuItem, { onClick: handleClickRenovacao, children: "Renova\u00E7\u00E3o" })] })] }), _jsx(RenderList, { titleField: function (processo) {
                    return processo.numero +
                        (processo.empresaRazaoSocial
                            ? ' - ' + processo.empresaRazaoSocial
                            : '');
                }, getStatus: getStatus, renderItem: function (processo) { return (_jsxs(_Fragment, { children: [_jsxs(Typography, { variant: "body2", children: ["Servi\u00E7o: ", processo.servicoCredenciamentoNome] }), _jsxs(Typography, { variant: "body2", children: ["Tipo:", ' ', processo.tipoFluxo === 'NOVO'
                                    ? 'Credenciamento Inicial'
                                    : 'Renovação'] }), _jsxs(Typography, { variant: "body2", children: ["Empresa: ", processo.empresaRazaoSocial] }), _jsxs(Typography, { variant: "body2", children: ["CNPJ: ", formatCnpj(processo.empresaCnpj)] }), _jsxs(Typography, { variant: "body2", children: ["Data de cria\u00E7\u00E3o: ", formatarData(processo.dataCriacao)] })] })); }, actionButtons: [
                    {
                        icon: _jsx(EditOutlinedIcon, {}),
                        color: 'primary',
                        onClick: function (processo) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, navigate("/processo/editar/dados-empresa/".concat(processo.id))];
                        }); }); },
                        visible: function (item) {
                            return item.situacao === SituacaoProcessoEnum.RASCUNHO ||
                                item.situacao === SituacaoProcessoEnum.PENDENTE;
                        },
                        tooltip: 'Editar',
                    },
                    {
                        icon: _jsx(VisibilityOutlinedIcon, {}),
                        color: 'primary',
                        onClick: function (processo) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, navigate("/processo/visualizar/dados-empresa/".concat(processo.id))];
                        }); }); },
                        tooltip: 'Visualizar',
                    },
                ] }), _jsx(PaginationComponent, {})] }));
};
